import React from 'react';
import Color from 'color';

const namedColors = {
  white: '#FFFFFF',
  gray: '#4A4A4A',
  black: '#000000',
  shadow1: '#282F37',
  shadow2: '#454E57',
  shadow3: '#848B94',
  shadow4: '#BEC4CC',
  shadow5: '#EDEFF0',
  error: '#D0021B',
};

namedColors.errorDark = Color(namedColors.error)
  .saturationv(93)
  .value(52)
  .string();

const Styles = {
  Colors: {
    ...namedColors,
  },
};

export default Styles;



// WEBPACK FOOTER //
// ./src/components/Style/Style.js